import { StepType } from 'src/app/shared/shared.module';
import {
    getInputField, setAsRequired, setRegexValidation,
    getSelectField, setAsRequiredEmail, getTypeAheadField, getDateField, getTelephoneField, setRequiredWhen, setDisableWhen, MinMaxAgeMustBe, getArrayPickerField, setAsDisabled, setYesNoValues
} from 'src/app/shared/form';
import { VisaType } from '../../visatypes';
import { nullSafe } from 'src/app/utils';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { isNullOrUndefined } from '../../../../../../app/core/utils';
import { FieldTooltip } from '../../field-tooltip.enum';
import { map } from 'rxjs/operators';

export class IqamaRenewal extends VisaType {


    GetRequesterSteps(operations?: () => string[]): StepType[] {

        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.EmpProfileSearch(null, operations),

                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.gpn(),
                            this.gui(),
                           // this.gpnGuiSearchButton(operations)
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.firstName(),
                            this.middleName(),
                            this.lastName()
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.nationalityTypeWithSpecialExpact(),  
                            this.nationality(),
                            // this.onboardingType(this.common.getPbTypeWrtNationality()),
                            getSelectField(
                                "specialExpat",
                                "Special expat",
                                setYesNoValues(this.common.getSpecialExpactWrtNationalityType(setAsRequired(this.addFieldTooltipWithAdditionalConfig('special expat')))
                            )),
                            this.passportNumber(),
                            this.passportExpiryDate('Passport expiry date'),
                            this.dateOfBirth(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future')),
                            this.placeOfBirth(),
                            this.mobileNumber(),
                            this.gender(),
                            getSelectField(
                                "serviceLine.id",
                                "Service line",
                                this.common.getSelectFieldOptions(this.serviceLines$, '',
                                    setAsRequired())
                            ),
                            getSelectField(
                                "subServiceLine.id",
                                "Sub-service line",
                                this.common.getSelectFieldOptions(this.subServiceLines$, "serviceLine.id",
                                    setAsRequired())
                            ),
                            this.rank(),
                            getSelectField(
                                "officeToBeVisited.id",
                                "Office location",
                                this.common.getSelectFieldOptions(this.officeLocation$, '', setAsRequired(this.addFieldTooltipWithAdditionalConfig('Office location')))
                            ),                                       
                            this.officeLE('EY legal entity'),
                        ]
                    }]
            },
            {
                label: "Step 2",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                    
                            // this.grade(),
                            getInputField(
                                "visaDesignation",
                                "Visa designation",
                                setAsRequired()
                            ),
                            getDateField("iqamaExpiryDate", 'Iqama expiry date ', setAsRequired(
                                setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                                    "Please enter a valid date in 'dd-mm-yyyy' format"))),

                            getInputField(
                                "iqamaId",
                                "Iqama ID",
                                setAsRequired()
                            ),
                            getSelectField(
                                "sponsorDepsInKSA.id",
                                "Do you plan to sponsor your dependents in KSA?",
                                this.common.getSelectFieldOptions(this.yesNo$, '',
                                    setAsRequired())
                            ),
                            getSelectField(
                                "depsAlreadyInKSA.id",
                                "Are your dependants already in KSA?",
                                setDisableWhen((model) => isNullOrUndefined(model.sponsorDepsInKSA.id) ||
                                    model.sponsorDepsInKSA.id === 1075,
                                    setRequiredWhen((model) => nullSafe<number>(() => model.sponsorDepsInKSA.id, -1) === 1074,
                                        this.common.getSelectFieldOptions(this.yesNo$, '')))
                            ),
                            getArrayPickerField('spouseDetails', 'Spouse details', this.spouseDetails('spouse'), 'spouse',
                            this.addFieldTooltipWithAdditionalConfig('spouse details',
                                setRequiredWhen((model) =>
                                    model.depsAlreadyInKSA.id === 1074,
                                    setDisableWhen((model) =>
                                        model.depsAlreadyInKSA.id === 1075 || isNullOrUndefined(model.depsAlreadyInKSA.id),
                                        null))), null, null, null
                        ),
                        getArrayPickerField('childrenDetails', 'Child details', this.childrenDetails('children'), 'children',
                        this.addFieldTooltipWithAdditionalConfig('Child details',
                            setRequiredWhen((model) =>
                                    model.depsAlreadyInKSA.id === 1074,
                                    setDisableWhen((model) =>
                                        model.depsAlreadyInKSA.id === 1075 || isNullOrUndefined(model.depsAlreadyInKSA.id),
                                        null))), null, null, null
                        ),
                        //     getArrayPickerField('spouseDetails', 'Spouse details', this.spouseDetails('spouse'), 'spouse',
                            
                        //         setRequiredWhen((model) =>
                        //             model.depsAlreadyInKSA.id === 1074,
                        //             setDisableWhen((model) =>
                        //                 model.depsAlreadyInKSA.id === 1075 || isNullOrUndefined(model.depsAlreadyInKSA.id),
                        //                 null))
                        //     ),
                        //     getArrayPickerField('childrenDetails', 'Child details', this.childrenDetails('children'), 'children',
                        //         setRequiredWhen((model) =>
                        //             model.depsAlreadyInKSA.id === 1074,
                        //             setDisableWhen((model) =>
                        //                 model.depsAlreadyInKSA.id === 1075 || isNullOrUndefined(model.depsAlreadyInKSA.id),
                        //                 null))
                        //   ),
                          this.RequestorName()
                        ]
                    },
                ]
            }
        ];

    }


    GetAccepterSteps(): StepType[] {
        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                          this.visaProcessorByOfficeLE(setAsRequired()),
                        //   this.Requestor()
                        ]
                    }
                ]
            }
        ];
    }

    GetApproverSteps(): StepType[] {

        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.visaProcessorByOfficeLE(
                                setAsRequired()
                                ),
                          this.immigrationStatus(),
                        //   this.Requestor(),
                          getDateField("iqamaExpiryDateRenewed", 'Iqama expiry date (renewed)', 
                          setAsRequired(
                            setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                                "Please enter a valid date in 'dd-mm-yyyy' format")
                                )
                                ),
                        ]
                    }
                ]
            }
        ];
    }


    private spouseDetails(_buttonAddText: string): FormlyFieldConfig[] {
        return (
            [
                {
                    key: 'formData',
                    type: 'repeat',
                    templateOptions: {
                        addText: `Add ${_buttonAddText}`,
                    },
                    fieldGroupClassName: "row",
                    fieldArray: {
                        fieldGroup: [
                            {
                                fieldGroupClassName: "row",
                                fieldGroup: [
                                    getInputField(
                                        "firstName",
                                        "First name (as per passport)",
                                        this.addFieldTooltipWithAdditionalConfig('Dependent First name',
                                        // tslint:disable-next-line: max-line-length
                                        setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' })))
                                    ),
                                    getInputField(
                                        "middleName",
                                        "Middle name (as per passport)",
                                        this.addFieldTooltipWithAdditionalConfig('Dependent Middle name',
                                        setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' }))
                                    ),
                                    getInputField("lastName", "Last name (as per passport)",
                                        this.addFieldTooltipWithAdditionalConfig('Dependent Last name',
                                        // tslint:disable-next-line: max-line-length
                                        setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' })))
                                    ),
                                ]
                            },
                            {
                                fieldGroupClassName: "row",
                                fieldGroup: [
                                    this.dateOfBirth(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future'
                                            , { className: 'col-md-4 mb-3' })),
                                    this.placeOfBirth(),
                                    this.gender(),
                                ]
                            },
                            {
                                fieldGroupClassName: "row",
                                fieldGroup: [
                                    getInputField("passportNumber", "Passport number", 
                                        this.addFieldTooltipWithAdditionalConfig('Dependent Passport number',
                                            setAsRequired({ className: 'col-md-4 mb-3' }))),
                                
                                    this.passportExpiryDate('Passport expiry date',
                                       ),
                                    getInputField("iqamaId", "Iqama ID", setAsRequired({ className: 'col-md-4 mb-3' })),
                                    this.nationalityType(),                                  
                                    
                                ]
                            }

                        ]
                    },
                },
            ]
        );
    }
    private childrenDetails(_buttonAddText: string): FormlyFieldConfig[] {
        return (
            [
                {
                    key: 'formData',
                    type: 'repeat',
                    templateOptions: {
                        addText: `Add ${_buttonAddText}`,
                    },
                    fieldGroupClassName: "row",
                    fieldArray: {
                        fieldGroup: [
                            {
                                fieldGroupClassName: "row",
                                fieldGroup: [
                                    getInputField(
                                        "firstName",
                                        "First name (as per passport)",
                                        // tslint:disable-next-line: max-line-length
                                        this.addFieldTooltipWithAdditionalConfig('Dependent First name',
                                        setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' }))
                                    )),
                                    getInputField(
                                        "middleName",
                                        "Middle name (as per passport)",
                                        this.addFieldTooltipWithAdditionalConfig('Dependent Middle name',setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' })
                                    )),
                                    getInputField("lastName", "Last name (as per passport)",
                                        // tslint:disable-next-line: max-line-length
                                        this.addFieldTooltipWithAdditionalConfig('Dependent Last name', setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' }))
                                    )),
                                ]
                            },
                            {
                                fieldGroupClassName: "row",
                                fieldGroup: [
                                    getDateField("dateOfBirth", "Date of birth", this.addFieldTooltipWithAdditionalConfig('Dependent Date of birth', setAsRequired(
                                        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                                            "Please enter a valid date in 'dd-mm-yyyy' format",
                                            this.common.AcceptDateBefore(0, "Date of birth cannot be a future date ",
                                                { className: 'col-md-4 mb-3' })),
                                    ))),
                                    this.placeOfBirth(),
                                    this.gender(),
                                ]
                            },
                            {
                                fieldGroupClassName: "row",
                                fieldGroup: [
                                    getInputField("passportNumber", "Passport number",this.addFieldTooltipWithAdditionalConfig('Dependent Passport number', setAsRequired({ className: 'col-md-4 mb-3' }))),
                                    getInputField("iqamaId", "Iqama ID", setAsRequired({ className: 'col-md-4 mb-3' })),
                                    this.nationalityType(),                                  
                                ]
                            }

                        ]
                    },
                },
            ]
        );
    }

}
